<template>
  <div id="map" style="width: 100%; height: 100%"></div>
</template>

<script>
import { SHIP_KEY } from '@/common/config'
import { appqueryOrderTruckInfoTrajectory } from '@/api/landCenter'

let _map = null

export default {
  props: ['id'],
  data () {
    return {

    }
  },
  methods: {
    initData () {
      appqueryOrderTruckInfoTrajectory({ id: this.id }).then(rsp => {
        if (rsp.data.trajectoryJson) {
          const json = JSON.parse(rsp.data.trajectoryJson)
          this.showTrajectory(json)
        }
      })
    },
    showTrajectory (json) {
      if (_map) _map.trackService.removeAll()
      var options = {
        lineColor: 'tomato', // 线，颜色
        lineWeight: 2, // 线，粗细
        dash: true, // 是否为虚线
        dashArray: [5, 5], // 虚线间隔
        circleOverColor: 'yellow', // 轨迹点,鼠标划过时颜色
        lableFields: ['lng', 'lat'],
        isDilute: true // 是否抽稀模式显示
      }

      let tracks = []
      for (var i = 0; i < json.length; i++) {
        // eslint-disable-next-line no-undef
        var track = new Track()
        // gtm '20210818/143018'
        const t = json[i]
        const gtm = t.gtm
        if (gtm) {
          const str = gtm.substr(0, 4) + '/' + gtm.substr(4, 2) + '/' + gtm.substr(6, 2) + ' ' + gtm.substr(9, 2) + ':' + gtm.substr(11, 2) + ':' + gtm.substr(13, 2)
          track.utc = new Date(str).getTime() / 1000 // （必填）
          track.lng = t.lon / 600000 // （必填）
          track.lat = t.lat / 600000 // （必填）
          track.sog = t.spd - 0 // （必填） 航速
          track.cog = t.agl - 0 // 航首向，正常值
          tracks.push(track)
        }
      }
      // 添加并显示轨迹
      _map.trackService.addAndShow('', tracks, options)
    }
  },
  mounted () {
    this.$nextTick(() => {
      // 创建地图示例
      // eslint-disable-next-line no-undef
      _map = new ShipxyAPI.Map('map', { ak: SHIP_KEY })
      // 开启轨迹服务
      // eslint-disable-next-line no-undef
      ShipxyAPI.TrackService(_map)
      // eslint-disable-next-line no-undef
      ShipxyAPI.ShipService(_map, {
        enableAreaShip: false, // 区域船
        enableFleetShip: false // 船队船
      })
      this.initData()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/page/orderTackH5ForT.vue